import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import * as fromRoot from '@app/store';
import * as fromUser from '@app/store/user';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.store.pipe(
      select(fromUser.getUser),
      filter(user => !!user), // Esperar a que el usuario esté cargado
      map(user => {
        const userRole = user?.role?.toUpperCase() || '';
        const allowedRoles = route.data['roles'] as string[] || [];
        
        // Si no hay roles especificados, permitir acceso
        if (allowedRoles.length === 0) {
          return true;
        }
        
        // Verificar si el rol del usuario está en la lista de roles permitidos
        const hasAccess = allowedRoles.map(role => role.toUpperCase()).includes(userRole);
        
        if (!hasAccess) {
          console.warn(`Acceso denegado. Rol requerido: ${allowedRoles.join(', ')}, Rol actual: ${userRole}`);
          // Redirigir a página de acceso denegado o home
          this.router.navigate(['/home']);
        }
        
        return hasAccess;
      })
    );
  }
}
